import React from 'react';
import { LabeledSectionSelectBox } from './LabeledSectionSelectBox';
import { MonthlySectionDataTable } from './MonthlySectionDataTable';
import { MonthlySectionDataChart } from './MonthlySectionDataChart';
import './styles.css';
import { LabeledSelectBox } from './LabeledSelectBox';
import { CollapsibleTableContainer } from './CollapsibleTableContainer';

export const MonthlySectionDataReport = ({
    rawData,
    isLoading,
    sections,
    sectionNumber,
    handleSectionChanged,
    startYear,
    handleStartYearChanged,
    yPropertyName,
    yAxisLabel
}) => {
    if (isLoading) {
        return <p>Loading manufacturer data...</p>;
    }

    if (!rawData) {
        return <p>Please select a manufacturer.</p>;
    }

    const selectedSectionNumber = sectionNumber && sections && sections.some(section => section.number === sectionNumber)
        ? sectionNumber
        : sections && sections.length > 0
            ? sections[0].number
            : null;
    let selectedSectionData = rawData && selectedSectionNumber
        ? rawData.filter(d => d.sectionNumber === selectedSectionNumber)
        : null;

    const years = selectedSectionData
        ? Array.from(
            new Set(selectedSectionData.map(d => parseInt(d.year))))
            .sort()
        : [];
    const startYearInt = parseInt(startYear);
    let tableData = rawData;
    if (startYearInt && selectedSectionData && years.includes(startYearInt)) {
        selectedSectionData = selectedSectionData.filter(d => d.year >= startYearInt);
        tableData = tableData.filter(d => d.year >= startYearInt);
    }

    return (
        <div>
            <LabeledSectionSelectBox sections={sections} selectedSectionNumber={selectedSectionNumber} onSectionChanged={handleSectionChanged} />
            <LabeledSelectBox
                label="Starting Year"
                items={years}
                selectedValue={startYearInt}
                onSelectionChanged={handleStartYearChanged} />
            <MonthlySectionDataChart rawData={selectedSectionData} yPropertyName={yPropertyName} yAxisLabel={yAxisLabel} />
            <CollapsibleTableContainer>
                <MonthlySectionDataTable rawData={tableData} dataMember={yPropertyName} />
            </CollapsibleTableContainer>
        </div >
    );
}
